import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  IconButton,
  Card,
  DialogTitle,
  TextField,
  TextareaAutosize,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "Components/Common/Dialog/DialogComponents";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import Button from "../../Components/Common/Button/Button";
import { ReactComponent as RepeatSmart } from "../../Assets/Logo/RepeatSmart.svg";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/CloseIcon.svg";
import { ReactComponent as ShareIcon } from "../../Assets/Icons/ShareIcon.svg";
import { ReactComponent as SendEmailIcon } from "../../Assets/Icons/SendIcon.svg";

import PrimaryIcon from "./PrimaryIcon";
import PaymentMain from "./PaymentMain/PaymentMain";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import {
  START_PAYMENT_LINK,
  START_SUBSCRIPTION_CANCEL,
  START_SUBSCRIPTION_CREATE,
  START_SUBSCRIPTION_UPDATE,
} from "../../Actions/HomeAction";
import { START_GET_LOGIN_USER } from "../../Actions/UserAction";
import PaymentLinkDialog from "./PaymentMain/PaymentLinkDialog";
import DisplayLinkDialog from "./PaymentMain/DisplayLinkDialog";
import useViewport from "../../Hooks/useViewport";
import moment from "moment";
import CancelPaymentDialog from "./PaymentMain/CancelPaymentDialog";
import UpdatePaymentDialog from "./PaymentMain/UpdatePaymentDialog";
const useStyle = makeStyles((theme) => ({
  dialogMain: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      top: "0 !important",
    },
    "& .MuiDialogTitle-root": {
      borderBottom: "none",
      "&>p": {
        "&>svg": {
          position: "relative",
          top: "18px",
          right: "28px",
        },
      },
    },
  },
  rsNoteGrid: {
    "& .MuiTableBody-root": {
      "&>tr": {
        "&>td": {
          padding: "12px 17px !important",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "10px",
    display: "flex !important",
    justifyContent: "end !important",
  },
  rsBillingTitle: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    textAlign: "center",
    color: "black  !important",
    marginTop: "20px",
    paddingBottom: "10px",
  },
  rsBillingSubtitle: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    textAlign: "center",
    color: "black  !important",
    marginTop: "20px",
    paddingRight: "5px",
  },
  rsCradSubtitle: {
    whiteSpace: "nowrap",
    fontSize: "12px !important",
    fontWeight: "500 !important",
    textAlign: "left",
    color: "black  !important",
    marginTop: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
    width: "150px",
    [theme.breakpoints.down("550")]: {
      width: "unset",
    },
    [theme.breakpoints.down("470")]: {
      fontSize: "12px !important",
    },
  },
  rsSubtitle: {
    display: "flex",
    textAlign: "center",
    width: "100%",
    justifyContent: "center",
  },
  rsBillingSubtitleBold: {
    // paddingTop: "15px",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    textAlign: "center",
    color: "rgba(123, 192, 68, 1) !important",
  },
  rsBillingSubtitleEmail: {
    paddingTop: "15px",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    textAlign: "center",
    color: "black  !important",
    marginTop: "20px",
  },
  rsBillingSubtitleBoss: {
    width: "70%",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    textAlign: "center",
    color: "black  !important",
    marginTop: "20px",
    marginLeft: "5px !important",
  },
  cardMain: {
    margin: "20px",
    width: "95%",
    padding: "20px",
    border: "2px",
    height: "fit-content",
    display: "flex",
    padding: "5px",
    background: "white",
    borderColor: "#EECA3C",
    borderStyle: "solid",
    justifyContent: "space-around",
    alignContent: "center",
    alignItems: "center",
    justifyItems: "center",
    borderRadius: "10px",
    "&>div": {
      "&>h4": {
        color: "#262626 !important",
        fontSize: "18px !important",
        fontWeight: "600 !important",
      },
    },
    "&>hr": {
      height: "80px",
      width: "1px",
      borderColor: "#EECA3C",
      borderStyle: "solid ",
      marginLeft: "-36px",
    },
    "&>button": {
      height: "35px !important",
      background: "rgba(238, 202, 60, 1) !important",
      borderRadius: "10px !important",
      fontSize: "18px !important",
      fontWeight: "500 !important ",
      // marginBottom: "20px",
    },
    [theme.breakpoints.down("550")]: {
      flexDirection: "column",
      marginTop: "20px",
      marginBottom: "20px",
      marginLeft: "0px",
      marginRight: "0px",
      "&>div:nth-child(1)": {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      "&>hr": {
        height: "1px",
        width: "80%",
        marginLeft: "0px",
        marginTop: "5px",
      },
    },
    // [theme.breakpoints.down("470")]: {
    //   padding: "10px",
    //   margin: "10px",
    //   width: "40%",
    // },
  },
  // ActivecardMain: {
  //   margin: "20px",
  //   width: "95%",
  //   padding: "20px",
  //   border: "3px",
  //   height: "fit-content",
  //   display: "grid",
  //   padding: "10px",
  //   background: "white",
  //   borderColor: "#7BC044",
  //   borderStyle: "solid",
  //   justifyContent: "center",
  //   alignContent: "center",
  //   alignItems: "center",
  //   justifyItems: "center",
  //   borderRadius: "10px",
  //   "&>button": {
  //     height: "35px !important",
  //     marginBottom: "20px",
  //   },
  //   [theme.breakpoints.down("470")]: {
  //     padding: "10px",
  //     margin: "10px",
  //     width: "40%",
  //   },
  // },
  ActivecardMain: {
    margin: "20px",
    width: "95%",
    padding: "20px",
    border: "2px",
    height: "fit-content",
    display: "flex",
    padding: "5px",
    background: "white",
    borderColor: "rgba(123, 192, 68, 1)",
    borderStyle: "solid",
    justifyContent: "space-around",
    alignContent: "center",
    alignItems: "center",
    justifyItems: "center",
    borderRadius: "10px",
    "&>div": {
      "&>h4": {
        color: "#262626 !important",
        fontSize: "18px !important",
        fontWeight: "600 !important",
      },
    },
    "&>hr": {
      height: "80px",
      width: "1px",
      borderColor: "rgba(123, 192, 68, 1)",
      borderStyle: "solid ",
      // marginLeft: "-23px",
    },
    "&>button": {
      height: "35px !important",
      // background: "rgba(238, 202, 60, 1) !important",
      borderRadius: "10px !important",
      fontSize: "18px !important",
      fontWeight: "500 !important ",
      // marginBottom: "20px",
    },
    [theme.breakpoints.down("550")]: {
      flexDirection: "column",
      marginTop: "20px",
      marginBottom: "20px",
      marginLeft: "0px",
      marginRight: "0px",
      "&>div:nth-child(1)": {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      "&>hr": {
        height: "1px",
        width: "80%",
        marginLeft: "0px",
        marginTop: "10px",
      },
    },
  },
  rsPrice: {
    fontSize: "30px !important",
    fontWeight: "500 !important",
    textAlign: "center",
    color: "black  !important",
    fontFamily: "Poppins",
    // paddingBottom: "10px",
    [theme.breakpoints.down("470")]: {
      fontSize: "20px !important",
    },
  },
  textplanperMonth: {
    fontSize: "14px !important",
    fontWeight: "300 !important",
    textAlign: "center",
    color: "black  !important",
    marginTop: "-10px",
  },
  textplan: {
    fontSize: "12px !important",
    fontWeight: "300 !important",
    textAlign: "center",
    color: "rgba(80, 80, 80, 0.6)  !important",

    paddingTop: "10px",
    [theme.breakpoints.down("470")]: {
      fontSize: "12px !important",
    },
  },
  textplanActive: {
    fontSize: "12px !important",
    fontWeight: "500 !important",
    textAlign: "center",
    color: "black  !important",
    // paddingBottom: "10px",
    [theme.breakpoints.down("470")]: {
      fontSize: "12px !important",
    },
  },
  textplanWxpire: {
    fontSize: "16px !important",
    fontWeight: "500 !important",
    textAlign: "center",
    color: "black  !important",
    paddingBottom: "5px",
    [theme.breakpoints.down("470")]: {
      fontSize: "12px !important",
    },
  },
  rsPriceTextMonth: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-5px",
  },
  rsPriceText: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  rsPriceTextExpire: {
    display: "grid",
    justifyContent: "center",
    alignItems: "center",
  },
  MainCard: {
    display: "block",
    justifyContent: "center",
    marginTop: "20px",
  },
  rsBillingLink: {
    color: "#4ebcf1 !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    textAlign: "center",
    textDecoration: "underline",
    marginBottom: "20px !important ",
    width: "90%",
    maxWidth: "fit-content",
    cursor: "pointer",
    [theme.breakpoints.down("470")]: {
      fontSize: "16px !important",
    },
  },
  rsBillingNumber: {
    color: "#4ebcf1 !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    textAlign: "center",
    marginBottom: "20px !important ",
    paddingRight: "3px",
    [theme.breakpoints.down("470")]: {
      fontSize: "16px !important",
    },
  },
  linkmain: {
    display: "flex",
    justifyContent: "center",
  },
  rsWarning: {
    marginTop: "50px",
    width: "290px",
  },
  rsWarningSubscription: {
    width: "88%",
    marginTop: "50px",
  },
  CloseIcon: {
    position: "absolute !important",
    top: "20px",
    right: "20px",
  },
  rsMain: {
    display: "inline-grid",
    textAlign: "center",
    justifyContent: "center",
    justifyItems: "center",
  },
  rsTextArea: {
    width: "100%",
    height: "200px !important",
    color: theme.palette.secondary.main,
    fontSize: "14px",
    fontFamily: "Poppins",
    marginTop: "20px",
    // background: "#d9d9d9",
  },
  rsTextAreatext: {
    marginTop: "20px  !important",
    height: "fit-content !important",
    "&>div": {
      height: "fit-content !important",
      padding: "10px  !important",
      "&>textarea": {
        overflow: "auto !important",
        height: "200px !important",
        border: "none !important",
        "&:focus-visible": {
          border: "none !important",
          outline: "none !important",
        },
        "&.Mui-focused ": {
          outline: "none !important",
          border: "none !important",
          borderColor: "transparent !important",
        },
      },
    },
  },
  Sendbutton: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
    justifyItems: "center",
    alignItems: "center",
    width: "-webkit-fill-available",
  },
  rsCardtextMain: {
    display: "grid",
    justifyItems: "flex-start",
    marginLeft: "-32px",
    [theme.breakpoints.down("550")]: {
      justifyItems: "center",
      marginLeft: "0px",
    },
  },
  rsCardtextMainActive: {
    display: "grid",
    justifyItems: "flex-start",
    // marginLeft: "-32px",
    [theme.breakpoints.down("600")]: {
      justifyItems: "center",
    },
    [theme.breakpoints.down("550")]: {
      justifyItems: "center",
      marginTop: "5px",
    },
  },
  marginLeftHr: {
    marginLeft: "-22px !important",
    [theme.breakpoints.down("550")]: {
      marginLeft: "0px !important",
    },
  },
}));

const BillingDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    paymentCreate,
    paymentLinkAdd,
    paymentLinkAction,
    subscriptionPayment,
    subscriptionCreate,
    subscriptionCancelAction,
    subscriptionCancel,
    getLoginUserAction,
    subscriptionUpdateAction,
    subscriptionUpdate,
    loginUserDetail,
  } = props;
  const [paymentMainDialog, setPaymentMainDialog] = useState(false);
  const [paymentLinkDialog, setPaymentLinkDialog] = useState(false);
  const [displayLinkDialog, setDisplayLinkDialog] = useState(false);
  const [paymentConfirmDialog, setpaymentConfirmDialog] = useState(false);
  const [paymentConfirmUpdate, setpaymentConfirmUpdateDialog] = useState(false);

  const [surgeryEmail, setSurgeryEmail] = useState("");
  const { width } = useViewport();
  const [duration, setDuration] = useState("");
  const [copyUrl, setCopyUrl] = useState("");
  const [message, setMessage] = useState();
  const [error, setError] = useState("");
  const [type, settype] = useState("");
  // const loginUserDetail = useSelector((state) => state.user);
  /**handle close dialog */
  const handleClose = () => {
    setOpen(false);
    setError("");
    setSurgeryEmail("");
  };
  useEffect(() => {
    setMessage(`Dear Boss,
  ${"\r\n"}Repeatsmart would be really beneficial for us to use .Here is a link for payment. 
  ${"\r\n"} Kind regards,
  ${"\r\n"} Your staff`);
  }, []);
  useEffect(() => {
    if (paymentLinkAdd?.data?.data?.is_add_url) {
      setPaymentLinkDialog(false);
      // setOpen(false);
      setError("");
      setSurgeryEmail("");
    } else {
      if (paymentLinkAdd?.data?.data?.url && paymentLinkDialog) {
        setPaymentLinkDialog(false);
        setDisplayLinkDialog(true);
      }
    }
  }, [paymentLinkAdd?.data?.success]);
  useEffect(() => {
    if (paymentCreate?.data?.success) {
      setOpen(false);
      setError("");
      setSurgeryEmail("");
    }
  }, [paymentCreate?.data?.success]);
  const handleLinkGenrate = () => {
    setPaymentLinkDialog(true);
  };
  let temp = 28;
  const [number, setnumber] = useState(0);

  useEffect(() => {
    if (loginUserDetail?.data?.data?.day_diff) {
      let numberPart = 0;
      const trimmedString = loginUserDetail?.data?.data?.day_diff.trim();
      const parts = trimmedString?.split(" ");
      numberPart = parts[0];
      const unitPart = parts[1];
      setnumber(numberPart);
    }
  }, [loginUserDetail?.data?.data]);

  const handleChange = (e) => {
    setSurgeryEmail(e.target.value);
    const isValidEmail = validateEmail(e.target.value);
    setError(isValidEmail ? "" : "Please enter valid email address");
  };
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };
  const handleChangeMessage = (e) => {
    setMessage(e.target.value);
  };
  useEffect(() => {
    if (open && !subscriptionCreate?.loading) {
      if (subscriptionCreate?.data?.success) {
        if (!paymentMainDialog) {
          setPaymentMainDialog(true);
        }
      }
    }
  }, [open, subscriptionCreate?.loading, subscriptionCreate?.data?.success]);
  useEffect(() => {
    if (!subscriptionCancel?.loading) {
      if (subscriptionCancel?.data?.success) {
        setpaymentConfirmDialog(false);
        setTimeout(() => {
          getLoginUserAction();
        }, 3000);
        // getLoginUserAction();
      }
    }
  }, [subscriptionCancel]);

  useEffect(() => {
    if (!subscriptionUpdate?.loading) {
      if (subscriptionUpdate?.data?.success) {
        setpaymentConfirmUpdateDialog(false);
        setTimeout(() => {
          getLoginUserAction();
        }, 3000);
        // getLoginUserAction();
      }
    }
  }, [subscriptionUpdate]);

  const handleCancel = () => {
    subscriptionCancelAction();
  };
  const handleUpdate = () => {
    subscriptionUpdateAction();
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        className={classes.dialogMain}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        {/* <DialogTitle >
         
        </DialogTitle> */}
        <IconButton className={classes.CloseIcon} onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon icon={CloseIcon} />{" "}
        </IconButton>
        <Box className={classes.rsMain}>
          {number < temp &&
            !loginUserDetail?.data?.data?.is_expired &&
            !loginUserDetail?.data?.data?.is_trial && (
              <Box className={classes.rsWarning}>
                Please renew your subscription now. Thank you.
              </Box>
            )}
          {loginUserDetail?.data?.data?.is_expired && (
            <Box className={classes.rsWarningSubscription}>
              We know that you are busy, so we have given you an extra 28 days
              to extend your Repeatsmart subscription! After this your account
              will be put on hold pending payment. Thank you.
            </Box>
          )}
          <Box>
            <PrimaryIcon
              style={
                width > 450
                  ? {
                      width: "280px",
                      height: "65px",
                      marginLeft: "10px",
                      marginTop: "30px",
                    }
                  : {
                      width: "220px",
                      height: "65px",
                      marginLeft: "10px",
                      marginTop: "30px",
                    }
              }
              icon={RepeatSmart}
              cursor="pointer"
            />
          </Box>
        </Box>
        {/* <PrimaryIcon
          style={{
            width: "100%",
            height: "65px",
            marginLeft: "10px",
            // marginBottom: "-22px",
          }}
          icon={RepeatSmart}
        /> */}

        <Box className={classes.rsNoteGrid}>
          <DialogContent>
            <Typography className={classes.rsBillingTitle}>
              {" "}
              Pricing{" "}
            </Typography>{" "}
            <Box className={classes.rsSubtitle}>
              <Typography className={classes.rsBillingSubtitle}>
                {`After your initial 12 week `} {` `}
              </Typography>
              <Typography className={classes.rsBillingSubtitleBold}>
                free trial
              </Typography>
            </Box>
            <Box className={classes.MainCard}>
              <Box
                className={
                  loginUserDetail?.data?.data?.plan_detail
                    ?.ps_subscription_end &&
                  loginUserDetail?.data?.data?.plan_detail
                    ?.ps_subscription_type == "6_month"
                    ? classes.ActivecardMain
                    : classes.cardMain
                }
              >
                <>
                  <Box>
                    <Typography variant="h4">Biannual</Typography>
                    {loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "6_month" && (
                        <Box className={classes.rsPriceTextA}>
                          <Typography className={classes.textplanActive}>
                            {"( Active Plan)"}
                          </Typography>
                        </Box>
                      )}
                  </Box>
                  <hr
                    className={
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "6_month" &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_cancel_date
                        ? classes.marginLeftHr
                        : ""
                    }
                  ></hr>
                  <Box
                    className={
                      !(
                        loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_end &&
                        loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_type == "6_month"
                      )
                        ? classes.rsCardtextMain
                        : classes.rsCardtextMainActive
                    }
                  >
                    {!(
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "6_month"
                    ) && (
                      <Box className={classes.rsPriceText}>
                        <Typography className={classes.rsPrice}>£23</Typography>
                        <Typography className={classes.textplan}>
                          +VAT
                        </Typography>
                      </Box>
                    )}

                    {loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "6_month" && (
                        <Box className={classes.rsPriceTextExpire}>
                          <Typography className={classes.textplanWxpire}>
                            {loginUserDetail?.data?.data?.plan_detail
                              ?.ps_subscription_cancel_date
                              ? "Subscrition end date"
                              : `Next subscription date `}
                          </Typography>
                          <Typography className={classes.textplanWxpire}>
                            {moment(
                              new Date(
                                loginUserDetail?.data?.data?.plan_detail
                                  ?.ps_subscription_cancel_date
                                  ? loginUserDetail?.data?.data?.plan_detail
                                      ?.ps_subscription_cancel_date
                                  : loginUserDetail?.data?.data?.plan_detail
                                      ?.ps_subscription_end
                              )
                            ).format("DD-MM-YYYY")}
                          </Typography>
                        </Box>
                      )}
                    {!(
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "6_month"
                    ) && (
                      <Box className={classes.rsPriceTextMonth}>
                        <Typography className={classes.textplanperMonth}>
                          {"per month"}
                        </Typography>
                      </Box>
                    )}
                    {!(
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "6_month"
                    ) && (
                      <Typography className={classes.rsCradSubtitle}>
                        {`£138+VAT billed every 6 months`}
                      </Typography>
                    )}
                  </Box>
                  <Button
                    variant="contained"
                    disabled={type == "6 month" && subscriptionCreate?.loading}
                    startIcon={
                      type == "6 month" &&
                      subscriptionCreate?.loading && (
                        <CircularProgress color="white" size="20px" />
                      )
                    }
                    onClick={() => {
                      settype("6 month");
                      setDuration("6 month");
                      let payload = {
                        duration: "6_month",
                      };
                      if (
                        loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_cancel_date == null
                      ) {
                        if (
                          loginUserDetail?.data?.data?.plan_detail
                            ?.ps_subscription_end &&
                          loginUserDetail?.data?.data?.plan_detail
                            ?.ps_subscription_type == "6_month"
                        ) {
                          setpaymentConfirmDialog(true);
                        } else {
                          if (
                            loginUserDetail?.data?.data?.plan_detail
                              ?.ps_subscription_type == "12_month"
                          ) {
                            setpaymentConfirmUpdateDialog(true);
                          } else {
                            subscriptionPayment(payload);
                          }
                        }
                      } else {
                        subscriptionPayment(payload);
                      }
                    }}
                  >
                    {loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_type == "6_month"
                      ? loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_cancel_date == null
                        ? "Cancel plan"
                        : "Subscribe"
                      : "Subscribe"}
                  </Button>
                </>
              </Box>
              <Box
                className={
                  loginUserDetail?.data?.data?.plan_detail
                    ?.ps_subscription_end &&
                  loginUserDetail?.data?.data?.plan_detail
                    ?.ps_subscription_type == "12_month"
                    ? classes.ActivecardMain
                    : classes.cardMain
                }
              >
                <>
                  <Box>
                    <Typography variant="h4">Annual</Typography>
                    {loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "12_month" && (
                        <Box className={classes.rsPriceText}>
                          <Typography className={classes.textplanActive}>
                            {"( Active Plan)"}
                          </Typography>
                        </Box>
                      )}
                  </Box>
                  <hr
                    className={
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "12_month" &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_cancel_date
                        ? classes.marginLeftHr
                        : ""
                    }
                  ></hr>
                  <Box
                    className={
                      !(
                        loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_end &&
                        loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_type == "12_month"
                      )
                        ? classes.rsCardtextMain
                        : classes.rsCardtextMainActive
                    }
                  >
                    {!(
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "12_month"
                    ) && (
                      <Box className={classes.rsPriceText}>
                        <Typography className={classes.rsPrice}>£20</Typography>
                        <Typography className={classes.textplan}>
                          +VAT
                        </Typography>
                      </Box>
                    )}

                    {loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "12_month" && (
                        <Box className={classes.rsPriceTextExpire}>
                          <Typography className={classes.textplanWxpire}>
                            {loginUserDetail?.data?.data?.plan_detail
                              ?.ps_subscription_cancel_date
                              ? "Subscrition end date"
                              : `Next subscription date `}
                          </Typography>
                          <Typography className={classes.textplanWxpire}>
                            {moment(
                              new Date(
                                loginUserDetail?.data?.data?.plan_detail
                                  ?.ps_subscription_cancel_date
                                  ? loginUserDetail?.data?.data?.plan_detail
                                      ?.ps_subscription_cancel_date
                                  : loginUserDetail?.data?.data?.plan_detail
                                      ?.ps_subscription_end
                              )
                            ).format("DD-MM-YYYY")}
                          </Typography>
                        </Box>
                      )}
                    {!(
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "12_month"
                    ) && (
                      <Box className={classes.rsPriceTextMonth}>
                        <Typography className={classes.textplanperMonth}>
                          {"per month"}
                        </Typography>
                      </Box>
                    )}
                    {!(
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_end &&
                      loginUserDetail?.data?.data?.plan_detail
                        ?.ps_subscription_type == "12_month"
                    ) && (
                      <Typography className={classes.rsCradSubtitle}>
                        {`£240+VAT billed every 12 months`}
                      </Typography>
                    )}
                  </Box>
                  {/* 
                  <Typography className={classes.rsCradSubtitle}>
                    {`1 year Repeatsmart subscription`}
                  </Typography>
                  {!(
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_type == "12_month"
                  ) && (
                    <Box className={classes.rsPriceText}>
                      <Typography className={classes.rsPrice}>£20</Typography>
                      <Typography className={classes.textplan}>
                        /month
                      </Typography>
                    </Box>
                  )}
                  {!(
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_type == "12_month"
                  ) && (
                    <Box className={classes.rsPriceText}>
                      <Typography className={classes.textplan}>
                        {"(plus VAT)"}
                      </Typography>
                    </Box>
                  )}
                  {loginUserDetail?.data?.data?.plan_detail
                    ?.ps_subscription_end &&
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_type == "12_month" && (
                      <Box className={classes.rsPriceText}>
                        <Typography className={classes.textplanActive}>
                          {"( Active Plan)"}
                        </Typography>
                      </Box>
                    )}
                  {loginUserDetail?.data?.data?.plan_detail
                    ?.ps_subscription_end &&
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_type == "12_month" && (
                      <Box className={classes.rsPriceTextExpire}>
                        <Typography className={classes.textplanWxpire}>
                          {loginUserDetail?.data?.data?.plan_detail
                            ?.ps_subscription_cancel_date
                            ? "Subscrition end date"
                            : `Next subscription date :`}
                        </Typography>
                        <Typography className={classes.textplanWxpire}>
                          {moment(
                            new Date(
                              loginUserDetail?.data?.data?.plan_detail?.ps_subscription_end
                            )
                          ).format("DD-MM-YYYY")}
                        </Typography>
                      </Box>
                    )} */}
                  <Button
                    variant="contained"
                    disabled={type == "12 month" && subscriptionCreate?.loading}
                    startIcon={
                      type == "12 month" &&
                      subscriptionCreate?.loading && (
                        <CircularProgress color="white" size="20px" />
                      )
                    }
                    onClick={() => {
                      settype("12 month");
                      setDuration("12 month");
                      let payload = {
                        duration: "12_month",
                      };
                      if (
                        loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_cancel_date == null
                      ) {
                        if (
                          loginUserDetail?.data?.data?.plan_detail
                            ?.ps_subscription_end &&
                          loginUserDetail?.data?.data?.plan_detail
                            ?.ps_subscription_type == "12_month"
                        ) {
                          setpaymentConfirmDialog(true);
                        } else {
                          if (
                            loginUserDetail?.data?.data?.plan_detail
                              ?.ps_subscription_type == "6_month"
                          ) {
                            setpaymentConfirmUpdateDialog(true);
                          } else {
                            subscriptionPayment(payload);
                          }
                        }
                      } else {
                        subscriptionPayment(payload);
                      }
                    }}
                  >
                    {loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_end &&
                    loginUserDetail?.data?.data?.plan_detail
                      ?.ps_subscription_type == "12_month"
                      ? loginUserDetail?.data?.data?.plan_detail
                          ?.ps_subscription_cancel_date == null
                        ? "Cancel plan"
                        : "Subscribe"
                      : "Subscribe"}
                  </Button>
                </>
              </Box>
            </Box>
            {(loginUserDetail?.data?.data?.is_expired ||
              loginUserDetail?.data?.data?.is_trial) && (
              <Box justifyItems={"center"} display={"grid"} paddingTop={"10px"}>
                <Box display={"flex"} justifyContent={"center"}>
                  <ShareIcon />
                  <Typography className={classes.rsBillingSubtitleBoss}>
                    If your boss is unavailable to pay, you can send them a
                    payment link via email:
                  </Typography>
                </Box>
                <Box justifyItems={"start"} display={"grid"} width="80%">
                  {/* <Typography className={classes.rsBillingSubtitleEmail}>
                    Enter email address
                  </Typography> */}
                  <TextField
                    variant="outlined"
                    fullWidth
                    size="medium"
                    name="email"
                    id="email"
                    label="Email *"
                    placeholder="Email"
                    value={surgeryEmail}
                    onChange={handleChange}
                    error={error}
                    helperText={error}
                  />
                  {/* <Typography className={classes.rsBillingSubtitleEmail}>
                    Custom message (optional)
                  </Typography> */}
                  <TextField
                    label="Message"
                    multiline
                    maxRows={5}
                    fullWidth
                    variant="outlined"
                    className={classes.rsTextAreatext}
                    onChange={(e) => handleChangeMessage(e)}
                    value={message}
                  />
                  {/* <TextareaAutosize
                    maxRows={1}
                    fullWidth
                    label="Message"
                    className={classes.rsTextArea}
                    aria-label="maximum height"
                    placeholder="Message"
                    id="useInfo"
                    onChange={(e) => handleChangeMessage(e)}
                    value={message}
                  /> */}
                  <Box className={classes.Sendbutton}>
                    <Button
                      startIcon={
                        <PrimaryIcon
                          color="white !important"
                          icon={SendEmailIcon}
                          // color="primary"
                          width="16px"
                          height="16px"
                        />
                      }
                      variant="contained"
                      onClick={() => {
                        if (surgeryEmail && error == "") {
                          handleLinkGenrate();
                          setCopyUrl("is_url");
                        } else {
                          setError("Please enter valid email.");
                        }
                      }}
                    >
                      Send Email
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
          </DialogContent>
        </Box>
      </Dialog>
      {type && (
        <PaymentMain
          open={paymentMainDialog}
          setOpen={setPaymentMainDialog}
          duration={type}
          setDuration={setDuration}
        />
      )}
      <PaymentLinkDialog
        open={paymentLinkDialog}
        setOpen={setPaymentLinkDialog}
        paymentLinkAction={paymentLinkAction}
        paymentLink={paymentLinkAdd}
        copyUrl={copyUrl}
        message={message}
        email={surgeryEmail}
      />
      <DisplayLinkDialog
        open={displayLinkDialog}
        setOpen={setDisplayLinkDialog}
        paymentStripLink={paymentLinkAdd?.data?.data?.url}
      />
      <CancelPaymentDialog
        open={paymentConfirmDialog}
        setOpen={setpaymentConfirmDialog}
        handleSubmit={handleCancel}
        loading={subscriptionCancel?.loading}
      />
      <UpdatePaymentDialog
        open={paymentConfirmUpdate}
        setOpen={setpaymentConfirmUpdateDialog}
        type={type}
        handleSubmit={handleUpdate}
        loading={subscriptionUpdate?.loading}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  paymentCreate: state.home.paymentCreate,
  paymentLinkAdd: state.home.paymentLinkAdd,
  subscriptionCreate: state.home.subscriptionCreate,
  subscriptionCancel: state.home.subscriptionCancel,
  subscriptionUpdate: state.home.subscriptionUpdate,
  loginUserDetail: state.user.loginUserDetail,
});
const mapDispatchToProps = (dispatch) => ({
  paymentLinkAction: (payload) =>
    dispatch({ type: START_PAYMENT_LINK, payload }),
  getLoginUserAction: () => dispatch({ type: START_GET_LOGIN_USER }),
  subscriptionPayment: (payload) =>
    dispatch({ type: START_SUBSCRIPTION_CREATE, payload }),
  subscriptionUpdateAction: (payload) =>
    dispatch({ type: START_SUBSCRIPTION_UPDATE, payload }),
  subscriptionCancelAction: (payload) =>
    dispatch({ type: START_SUBSCRIPTION_CANCEL, payload }),
});
export default connect(mapStateToProps, mapDispatchToProps)(BillingDialog);